module.exports = "<h1>register</h1>\n<button (click)=\"submit()\">Submit</button>\n"